<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 16px;
    background: #F58020;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
      color: #fff;
    }
  }
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;

  .search-box {
    position: relative;
    flex: 1;
    min-width: 200px;
    max-width: 320px;

    i {
      position: absolute;
      left: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #a0aab8;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 36px;
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      padding: 0 12px 0 32px;
      font-size: 13px;
      color: #0d1b3e;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder {
        color: #b0bac9;
      }

      &:focus {
        border-color: #389ad4;
        box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
      }
    }
  }

  .status-filter {
    height: 36px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
    color: #0d1b3e;
    background: #fff;
    outline: none;
    cursor: pointer;
    transition: border-color 0.2s;

    &:focus {
      border-color: #389ad4;
      box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
    }
  }
}

/* ── Table ── */
.sp-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
  table-layout: fixed;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 10px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f8fbff;
    }

    td {
      padding: 10px 10px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

/* ── Provider avatar ── */
.sp-avatar {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #f0f4fa;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.sp-name {
  font-weight: 500;
  color: #0d1b3e;
}

.sp-address {
  font-size: 12px;
  color: #7a8499;
  margin-top: 2px;
}

.sp-timezone {
  font-size: 12px;
  color: #4a5568;
  word-break: break-word;
}

/* ── Badges ── */
.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  &.active {
    background: #c6f6d5;
    color: #276749;
  }

  &.inactive {
    background: #fed7d7;
    color: #c53030;
  }

  &.qb-yes {
    background: #c6f6d5;
    color: #276749;
  }

  &.qb-no {
    background: #e2e8f0;
    color: #718096;
  }
}

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 150px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 100;
    overflow: hidden;

    &.dropup {
      top: auto;
      bottom: calc(100% + 4px);
    }

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      transition: background 0.15s;

      i {
        width: 16px;
        font-size: 13px;
      }

      &:hover {
        background: #f8fbff;
      }

      &.blue {
        color: #185FA5;

        i {
          color: #185FA5;
        }

        &:hover {
          background: #eef2fb;
          color: #1E6FB8;

          i {
            color: #1E6FB8;
          }
        }
      }

      &.success {
        color: #276749;

        i {
          color: #276749;
        }

        &:hover {
          background: #f0fdf4;
          color: #1d5230;

          i {
            color: #1d5230;
          }
        }
      }

      &.orange {
        color: #c05621;

        i {
          color: #c05621;
        }

        &:hover {
          background: #fff7ed;
          color: #9c4318;

          i {
            color: #9c4318;
          }
        }
      }

      &.danger {
        color: #c62828;

        i {
          color: #c62828;
        }

        &:hover {
          background: #fff5f5;
          color: #9b1c1c;

          i {
            color: #9b1c1c;
          }
        }
      }
    }
  }

  &.open .action-menu {
    display: block;
  }
}

/* ── Empty / loading ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 30px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;

  .pg-info {
    font-size: 12px;
    color: #7a8499;
    white-space: nowrap;
  }

  .pg-controls {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .pg-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border: 1.5px solid #dde2ec;
    background: #fff;
    color: #4a5568;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;

    &:hover:not(:disabled) {
      border-color: #389ad4;
      color: #389ad4;
    }

    &:disabled {
      opacity: 0.35;
      cursor: default;
    }

    &.active {
      background: #389ad4;
      border-color: #389ad4;
      color: #fff;
    }
  }

  .pg-size select {
    height: 32px;
    border: 1.5px solid #dde2ec;
    border-radius: 6px;
    padding: 0 8px;
    font-size: 12px;
    color: #4a5568;
    background: #fff;
    cursor: pointer;
    outline: none;

    &:focus {
      border-color: #389ad4;
    }
  }
}
</style>

<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-building"></i>
          Service Providers
          <span style="font-size:12px; color:#7a8499; font-weight:400;" v-if="filteredserviceprovider.length">
            ({{ filteredserviceprovider.length }})
          </span>
        </span>
        <router-link :to="{ name: 'admin.serviceprovider.create' }" class="btn-add">
          <i class="fa fa-plus"></i> Add Service Provider
        </router-link>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input type="text" placeholder="Search by name…" v-model="searchInput" />
        </div>
        <select class="status-filter" v-model="status">
          <option value="all">All Status</option>
          <option :value="true">Active</option>
          <option :value="false">Inactive</option>
        </select>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="loadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading service providers…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="filteredserviceprovider.length === 0">
        <i class="fa fa-building-o"></i>
        No service providers found
      </div>

      <!-- Table -->
      <div v-else>
        <table class="sp-table">
          <thead>
            <tr>
              <th style="width:36px;">#</th>
              <th style="width:54px;"></th>
              <th style="width:180px;">Name / Address</th>
              <th style="width:130px;">Time Zone</th>
              <th style="width:110px; text-align:center;">QuickBooks</th>
              <th style="width:96px; text-align:center;">Status</th>
              <th style="width:54px; text-align:center;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pagedList" :key="item.id || index">
              <td style="color:#a0aab8; font-size:12px;">{{ (currentPage - 1) * perPage + index + 1 }}</td>
              <td>
                <div class="sp-avatar" :style="item.image ? { backgroundImage: 'url(' + url + item.image + ')' } : {}">
                  <span v-if="!item.image"
                    style="display:flex;align-items:center;justify-content:center;height:100%;color:#b0bac9;font-size:18px;">
                    <i class="fa fa-building-o"></i>
                  </span>
                </div>
              </td>
              <td>
                <div class="sp-name">{{ item.name }}</div>
                <div class="sp-address">{{ item.full_address }}</div>
              </td>
              <td class="sp-timezone">{{ item.client_timezone || '—' }}</td>
              <td style="text-align:center;">
                <span v-if="currentUser.u.is_admin"
                  :class="['badge-pill', item.is_admin_quickbooks_synced ? 'qb-yes' : 'qb-no']">
                  <i :class="item.is_admin_quickbooks_synced ? 'fa fa-check' : 'fa fa-times'"></i>
                  {{ item.is_admin_quickbooks_synced ? 'Synced' : 'Not Synced' }}
                </span>
                <span v-else :class="['badge-pill', item.is_quickbooks_synced ? 'qb-yes' : 'qb-no']">
                  <i :class="item.is_quickbooks_synced ? 'fa fa-check' : 'fa fa-times'"></i>
                  {{ item.is_quickbooks_synced ? 'Synced' : 'Not Synced' }}
                </span>
              </td>
              <td style="text-align:center;">
                <span :class="['badge-pill', item.is_active ? 'active' : 'inactive']">
                  <i :class="item.is_active ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                  {{ item.is_active ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td style="text-align:center; overflow:visible;" @click.stop>
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)" :ref="`dropdown-${index}`">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :class="{ dropup: dropupIndex === index }">
                    <div class="menu-item blue" @click.stop="editItem(item.id)">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </div>
                    <div class="menu-item success" @click.stop="openLocationUsers(item.id)">
                      <i class="fa fa-users"></i> Users
                    </div>
                    <div class="menu-item orange" @click.stop="editRate(item.id)">
                      <i class="fa fa-dollar-sign"></i> Rate
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="filteredserviceprovider.length > perPage">
        <span class="pg-info">
          Showing {{ (currentPage - 1) * perPage + 1 }}–{{ Math.min(currentPage * perPage,
            filteredserviceprovider.length) }}
          of {{ filteredserviceprovider.length }}
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage = 1">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage--">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === currentPage }"
            @click="currentPage = p">{{ p }}</button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage++">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage = totalPages">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
        <div class="pg-size">
          <select v-model="perPage" @change="currentPage = 1">
            <option :value="10">10 / page</option>
            <option :value="25">25 / page</option>
            <option :value="50">50 / page</option>
          </select>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { GET_SERVICE_PROVIDER_LIST } from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentUser", "getserviceProviders"]),
    filteredserviceprovider() {
      let list = this.getserviceProviders || [];
      if (this.searchInput) {
        list = list.filter(item =>
          item.name.toUpperCase().includes(this.searchInput.toUpperCase())
        );
      }
      if (this.status !== "all") {
        list = list.filter(item => item.is_active == this.status);
      }
      return list;
    },
    totalPages() {
      return Math.ceil(this.filteredserviceprovider.length / this.perPage) || 1;
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredserviceprovider.slice(start, start + this.perPage);
    },
    visiblePages() {
      const total = this.totalPages;
      const cur = this.currentPage;
      const pages = [];
      for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  watch: {
    filteredserviceprovider() {
      this.currentPage = 1;
    }
  },
  data() {
    return {
      status: true,
      loadingData: false,
      searchInput: "",
      url: "",
      currentPage: 1,
      perPage: 10,
      openIndex: null,
      dropupIndex: null,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Service Providers", route: "" }
      ]
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getServiceProvider();
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    openLocationUsers(id) {
      this.$router.push({ name: "admin.serviceprovider.location.users", params: { id } });
    },
    editItem(id) {
      this.$router.push({ name: "admin.serviceprovider.edit", params: { id } });
    },
    editRate(id) {
      this.$router.push({ name: "admin.serviceprovider.rate", params: { id } });
    },
    toggleDropdown(index, event) {
      this.openIndex = this.openIndex === index ? null : index;
      if (this.openIndex === index) {
        this.$nextTick(() => {
          const el = event.currentTarget;
          const menu = el.querySelector(".action-menu");
          if (menu) {
            const rect = el.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            this.dropupIndex = spaceBelow < (menu.scrollHeight || 120) + 30 ? index : null;
          }
        });
      } else {
        this.dropupIndex = null;
      }
    },
    closeDropdown() {
      this.openIndex = null;
      this.dropupIndex = null;
    },
    getServiceProvider() {
      this.loadingData = true;
      this.$store.dispatch(GET_SERVICE_PROVIDER_LIST)
        .then(res => {
          if (res.code == 200) this.url = res.url;
          this.loadingData = false;
        })
        .catch(() => { this.loadingData = false; });
    }
  }
};
</script>
